<template>
  <ValidationObserver ref="form">
    <form
      @submit.prevent="submit"
      class="custom-contact-add"
    >
      <dt-modal v-model="isVisible">
        <div slot="header">
          <h4 class="modal-title">
            Add {{ contactTitle }}
          </h4>
        </div>
        <div
          slot="body"
          class="custom-body"
        >
          <div class="row">
            <div class="form-group col-md-12">
              <dt-select
                v-model="contactType"
                v-show="showType && !isCompany"
                label="Contact Type"
                name="contactType"
                :options="lookups['ContactType']"
                validate="required"
              />
              <dt-select
                v-model="salutation"
                label="Salutation"
                name="salutation"
                v-show="!isCompany"
                :options="lookups['Salutation']"
              />
              <dt-input
                v-model="firstName"
                name="firstName"
                label="First Name"
                v-show="!isCompany"
                :validate="!isCompany ? 'required' : ''"
              />
              <dt-input
                v-model="lastName"
                name="lastName"
                :label="nameLabel"
                validate="required"
              />
              <dt-select
                v-model="timezone"
                label="Time Zone"
                name="timezone"
                :options="lookups['TimeZone']"
                validate="required"
              />
              <dt-select
                v-model="language"
                label="Language"
                name="language"
                :options="lookups['Language']"
                validate="required"
              />
              <dt-input
                v-model="insuranceId"
                name="insuranceId"
                label="Id #"
              />
              <dt-input
                v-model="insuranceNumber"
                name="insuranceNumber"
                label="Reference"
              />
              <dt-textarea
                v-model="notes"
                name="Notes"
                label="Notes"
              />
            </div>
          </div>
        </div>
        <div
          slot="footer"
          class="custom-footer"
        >
          <div class="col-md-7 text-center">
            <span>Firm: {{ firm }}</span>
          </div>
          <div class="col-md-5 form-inline">
            <div class="col-md-6">
              <button
                type="button"
                class="btn btn-light"
                @click="close()"
              >
                <span v-if="view !== 'View'">Cancel</span>
                <span v-else>Close</span>
              </button>
            </div>
            <div class="col-md-6">
              <button
                type="submit"
                class="btn btn-primary"
                v-show="view !=='View'"
              >Save</button>
            </div>
          </div>
        </div>
      </dt-modal>
    </form>
  </ValidationObserver>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import DtModal from '@/components/utilities/modal/dt-modal.vue'
import DtInput from '@/components/utilities/form/dt-input'
import DtSelect from '@/components/utilities/form/dt-select'
import DtTextarea from '@/components/utilities/form/dt-textarea'
export default {
  name: 'contact-add',
  components: {
    DtModal,
    DtInput,
    DtSelect,
    DtTextarea
  },
  props: {
    value: {
      type: Boolean
    },
    view: String,
    showType: {
      type: Boolean,
      default: true
    },
    contactTitle: {
      type: String,
      default: 'Contact'
    },
    isCompany: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('lookups', ['lookups']),
    ...mapGetters('contacts', ['contact']),
    firm: {
      get() {
        return this.contact !== null ? this.contact.firm : ''
      }
    },
    nameLabel: {
      get() {
        let _label = 'Last Name'
        if (this.isCompany) {
          _label = 'Name'
        }
        return _label
      }
    },
    contactType: {
      get() {
        return this.contact !== null ? this.contact.contactType : 0
      },
      set(value) {
        var data = {
          name: 'contactType',
          value: value
        }
        this.updateContact(data)
      }
    },
    salutation: {
      get() {
        return this.contact !== null ? this.contact.salutation : 0
      },
      set(value) {
        var data = {
          name: 'salutation',
          value: value
        }
        this.updateContact(data)
      }
    },
    firstName: {
      get() {
        return this.contact !== null ? this.contact.firstName : ''
      },
      set(value) {
        var data = {
          name: 'firstName',
          value: value
        }
        this.updateContact(data)
      }
    },
    lastName: {
      get() {
        return this.contact !== null ? this.contact.lastName : ''
      },
      set(value) {
        var data = {
          name: 'lastName',
          value: value
        }
        this.updateContact(data)
      }
    },
    insuranceId: {
      get() {
        return this.contact !== null ? this.contact.insuranceId : ''
      },
      set(value) {
        var data = {
          name: 'insuranceId',
          value: value
        }
        this.updateContact(data)
      }
    },
    insuranceNumber: {
      get() {
        return this.contact !== null ? this.contact.insuranceNumber : ''
      },
      set(value) {
        var data = {
          name: 'insuranceNumber',
          value: value
        }
        this.updateContact(data)
      }
    },
    timezone: {
      get() {
        return this.contact !== null ? this.contact.timezone : ''
      },
      set(value) {
        this.updateContact({
          name: 'timezone',
          value: value
        })
      }
    },
    language: {
      get() {
        return this.contact !== null ? this.contact.language : ''
      },
      set(value) {
        this.updateContact({
          name: 'language',
          value: value
        })
      }
    },
    notes: {
      get() {
        return this.contact !== null ? this.contact.notes : ''
      },
      set(value) {
        var data = {
          name: 'notes',
          value: value
        }
        this.updateContact(data)
      }
    },
    isVisible: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    ...mapActions('contacts', ['updateContact']),
    close() {
      this.$emit('closing')
    },
    async submit() {
      let notice = 'Please supply fill all fields.'
      this.$refs.form.validate().then(success => {
        let valid = true
        if (success) {
          if (this.contact.timezone === 0) {
            valid = false
            notice += '  Please supply a Timezone.'
          }
          if (this.contact.language === 0) {
            valid = false
            notice += '  Please supply a Language.'
          }
          if (valid) {
            console.log('Saving Contact', this.contact)
            this.$emit('send', this.contact)
          } else {
            alert(notice)
          }
        } else {
          alert(notice)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-contact-add {
  z-index: 2000;
}
.custom-body {
  overflow: auto;
  overflow-x: hidden;
  max-height: 400px;
  padding-right: 15px;
}
.custom-footer {
  width: 100%;
  display: inline-flex;
}
</style>



// WEBPACK FOOTER //
// src/components/contacts/forms/contact-add.vue